import InhouseLoader from "src/components/InhouseLoader/InhouseLoader";

const DrawerSkeleton = () => (
  <div className="w-full flex flex-col h-full items-center justify-center gap-4 px-6">
    <InhouseLoader size={48} />
    <div className="flex flex-col items-center gap-1.5 animate-fadeIn">
      <p className="font-['DM_Sans'] font-semibold text-[16px] text-[#25242A]">
        Reviewing your case
      </p>
      <p className="font-['DM_Sans'] font-normal text-[13px] text-[#6B7280] text-center">
        Working out where a lawyer can help you most
      </p>
    </div>
  </div>
);

export default DrawerSkeleton;
